import { ReactNode } from "react"
import Link from "../../common/Link"
import { TableColumn } from "../../common/Table"
import { CategoryMatch } from "../../helpers/interfaces/category"
import { IMatchData } from "../../helpers/interfaces/matchData"
import { ITeamRank } from "../../helpers/interfaces/ranking"
import { Button } from "react-bootstrap"

export const rankingColumns: TableColumn<ITeamRank>[] = [
    {
        id: "position",
        name: "N°",
        data: null,
        render: (_data: null, index: number, _row) => {
            return <div className="position" style={{ backgroundColor: _row.colore ?? "transparent" }}>{index + 1}</div>
        }
    },
    {
        id: "team",
        name: "Squadra",
        data: "nomeSquadra",
        render: (data: string, _index: number, row) => {
            return <Link
                href={`/societa/${row.idSquadra}`}
                title={data}
                className="col-12 text-truncate"
            >
                {data}
                {Number(row.penality) > 0 && ` (-${row.penality})`}
            </Link>
        }
    },
    {
        id: "points",
        name: "Punti",
        data: "punti"
    },
    {
        id: "partiteGiocate",
        name: "Giocate",
        data: "partiteGiocate",
        render: (data: string, _index: number, row) => {
            return <Link
                href={`/societa/${row.idSquadra}?season=${row.stagione}#tab_matches_categories`}
                className="col-12"
            >
                {data}
            </Link>
        }
    },
    {
        id: "v",
        name: "V",
        data: "partiteVinte"
    },
    {
        id: "n",
        name: "N",
        data: "partitePareggiate"
    },
    {
        id: "p",
        name: "P",
        data: "partitePerse"
    },
    {
        id: "gf",
        name: "GF",
        data: "goalFatti"
    },
    {
        id: "gs",
        name: "GS",
        data: "goalSubiti"
    },
    {
        id: "dr",
        name: "DR",
        data: "differenzaReti"
    },
    {
        id: "coeff",
        name: "Coeff",
        data: "coefficiente"
    }
]

export const getCategoryMatchesColumns = (
    expandedMatchId: number | null,
    onToggleExpand: (id: number | null) => void
) => [
    {
        id: "status",
        name: "Stato",
        data: null,
        render: (_data: any, _index: number, row: CategoryMatch) => {
            if (row.rinviata === '1')
                return <i className="fa fa-circle rinviata" aria-hidden="true" />
            if (row.chiusa === '1')
                return <i className="fa fa-circle terminata" aria-hidden="true" />
            if (row.inCorso === '1')
                return <i className="fa fa-circle in-corso" aria-hidden="true" />
            if (row.sospesa === '1')
                return <i className="fa fa-circle sospesa" aria-hidden="true" />
            if (row.inCorso === '0' && row.chiusa === '0')
                return <i className="fa fa-circle-o da-giocare" aria-hidden="true" />
        }
    },
    {
        id: "ora",
        name: "Orario",
        data: "ora",
        render: (data: string, _index: number, row: IMatchData) => {
            return <>
                {row.data} {row.ora}
                    </>
        }
    },
    {
        id: "casa",
        name: "Casa",
        data: "nomeA",
        render: (data: string, _index: number, row: IMatchData) => {
            const isExpanded = expandedMatchId === row.idPartita;

            return (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <Link href={`/societa/${row.idSquadraA}`} title={data}>
                        {data}
                    </Link>

                    {isExpanded && row.marcatoriA.length > 0 && (
                        <div style={{ marginTop: "2px", fontSize: "0.85rem", textAlign: "center" }}>
                            {row.marcatoriA.map((m) => (
                                <div key={m.idMarcatore}>
                                    {m.goal} - {m.nome}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )
        }
    },
    {
        id: "risultato",
        name: "Punteggio",
        data: "risultato",
        render: (data: string, _index: number, row: IMatchData) => {
            const isExpanded = expandedMatchId === row.idPartita;

            const handleClick = () => {
                if (!onToggleExpand || data === "-") return;

                if (isExpanded) {
                    onToggleExpand(null); // chiude
                } else {
                    onToggleExpand(row.idPartita); // apre
                }
            };

            return (
                <div className="result-cell">
                    <span
                        onClick={handleClick}
                        className={data !== "-" ? "clickable" : ""}
                    >
                    {data}
                    </span>
                    {row.info && (
                        <div className="result-info">
                            {row.info}
                        </div>
                    )}
                </div>
            );
        }
    },
    {
        id: "trasferta",
        name: "Trasferta",
        data: "nomeB",
        render: (data: string, _index: number, row: IMatchData) => {
            const isExpanded = expandedMatchId === row.idPartita;

            return (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <Link href={`/societa/${row.idSquadraB}`} title={data}>
                        {data}
                    </Link>

                    {isExpanded && row.marcatoriB.length > 0 && (
                        <div style={{ marginTop: "2px", fontSize: "0.85rem", textAlign: "center" }}>
                            {row.marcatoriB.map((m) => (
                                <div key={m.idMarcatore}>
                                    {m.goal} - {m.nome}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            );
        },
    },
    {
        id: "risultati",
        name: "Risultati",
        data: null,
        render: (_data: null, _index: number, _row: IMatchData) => {
            return <div className="h-100 d-flex align-items-center justify-content-center">
                <Button data-id={"send-results-" + _row.idPartita} id={"send-results-" + _row.idPartita} className="send-results-btn btn btn-light rounded-4 d-flex fw-bold p-1 border" variant="circle" size="sm">
                    <span className="fs-small me-2">Invia</span>
                    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <rect y="0.785156" width="21.4286" height="21.4286" rx="10.7143" fill="url(#pattern0_618_16230)" />
                        <defs>
                            <pattern id="pattern0_618_16230" patternContentUnits="objectBoundingBox" width="1" height="1">
                                <use xlinkHref="#image0_618_16230" transform="scale(0.025)" />
                            </pattern>
                            <image id="image0_618_16230" width="40" height="40" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAABGdBTUEAALGPC/xhBQAACjFpQ0NQSUNDIHByb2ZpbGUAAEiJnZZ3VFPZFofPvTe9UJIQipTQa2hSAkgNvUiRLioxCRBKwJAAIjZEVHBEUZGmCDIo4ICjQ5GxIoqFAVGx6wQZRNRxcBQblklkrRnfvHnvzZvfH/d+a5+9z91n733WugCQ/IMFwkxYCYAMoVgU4efFiI2LZ2AHAQzwAANsAOBws7NCFvhGApkCfNiMbJkT+Be9ug4g+fsq0z+MwQD/n5S5WSIxAFCYjOfy+NlcGRfJOD1XnCW3T8mYtjRNzjBKziJZgjJWk3PyLFt89pllDznzMoQ8GctzzuJl8OTcJ+ONORK+jJFgGRfnCPi5Mr4mY4N0SYZAxm/ksRl8TjYAKJLcLuZzU2RsLWOSKDKCLeN5AOBIyV/w0i9YzM8Tyw/FzsxaLhIkp4gZJlxTho2TE4vhz89N54vFzDAON40j4jHYmRlZHOFyAGbP/FkUeW0ZsiI72Dg5ODBtLW2+KNR/Xfybkvd2ll6Ef+4ZRB/4w/ZXfpkNALCmZbXZ+odtaRUAXesBULv9h81gLwCKsr51Dn1xHrp8XlLE4ixnK6vc3FxLAZ9rKS/o7/qfDn9DX3zPUr7d7+VhePOTOJJ0MUNeN25meqZExMjO4nD5DOafh/gfB/51HhYR/CS+iC+URUTLpkwgTJa1W8gTiAWZQoZA+J+a+A/D/qTZuZaJ2vgR0JZYAqUhGkB+HgAoKhEgCXtkK9DvfQvGRwP5zYvRmZid+8+C/n1XuEz+yBYkf45jR0QyuBJRzuya/FoCNCAARUAD6kAb6AMTwAS2wBG4AA/gAwJBKIgEcWAx4IIUkAFEIBcUgLWgGJSCrWAnqAZ1oBE0gzZwGHSBY+A0OAcugctgBNwBUjAOnoAp8ArMQBCEhcgQFVKHdCBDyByyhViQG+QDBUMRUByUCCVDQkgCFUDroFKoHKqG6qFm6FvoKHQaugANQ7egUWgS+hV6ByMwCabBWrARbAWzYE84CI6EF8HJ8DI4Hy6Ct8CVcAN8EO6ET8OX4BFYCj+BpxGAEBE6ooswERbCRkKReCQJESGrkBKkAmlA2pAepB+5ikiRp8hbFAZFRTFQTJQLyh8VheKilqFWoTajqlEHUJ2oPtRV1ChqCvURTUZros3RzugAdCw6GZ2LLkZXoJvQHeiz6BH0OPoVBoOhY4wxjhh/TBwmFbMCsxmzG9OOOYUZxoxhprFYrDrWHOuKDcVysGJsMbYKexB7EnsFO459gyPidHC2OF9cPE6IK8RV4FpwJ3BXcBO4GbwS3hDvjA/F8/DL8WX4RnwPfgg/jp8hKBOMCa6ESEIqYS2hktBGOEu4S3hBJBL1iE7EcKKAuIZYSTxEPE8cJb4lUUhmJDYpgSQhbSHtJ50i3SK9IJPJRmQPcjxZTN5CbiafId8nv1GgKlgqBCjwFFYr1Ch0KlxReKaIVzRU9FRcrJivWKF4RHFI8akSXslIia3EUVqlVKN0VOmG0rQyVdlGOVQ5Q3mzcovyBeVHFCzFiOJD4VGKKPsoZyhjVISqT2VTudR11EbqWeo4DUMzpgXQUmmltG9og7QpFYqKnUq0Sp5KjcpxFSkdoRvRA+jp9DL6Yfp1+jtVLVVPVb7qJtU21Suqr9XmqHmo8dVK1NrVRtTeqTPUfdTT1Lepd6nf00BpmGmEa+Rq7NE4q/F0Dm2OyxzunJI5h+fc1oQ1zTQjNFdo7tMc0JzW0tby08rSqtI6o/VUm67toZ2qvUP7hPakDlXHTUegs0PnpM5jhgrDk5HOqGT0MaZ0NXX9dSW69bqDujN6xnpReoV67Xr39An6LP0k/R36vfpTBjoGIQYFBq0Gtw3xhizDFMNdhv2Gr42MjWKMNhh1GT0yVjMOMM43bjW+a0I2cTdZZtJgcs0UY8oyTTPdbXrZDDazN0sxqzEbMofNHcwF5rvNhy3QFk4WQosGixtMEtOTmcNsZY5a0i2DLQstuyyfWRlYxVtts+q3+mhtb51u3Wh9x4ZiE2hTaNNj86utmS3Xtsb22lzyXN+5q+d2z31uZ27Ht9tjd9Oeah9iv8G+1/6Dg6ODyKHNYdLRwDHRsdbxBovGCmNtZp13Qjt5Oa12Oub01tnBWex82PkXF6ZLmkuLy6N5xvP48xrnjbnquXJc612lbgy3RLe9blJ3XXeOe4P7Aw99D55Hk8eEp6lnqudBz2de1l4irw6v12xn9kr2KW/E28+7xHvQh+IT5VPtc99XzzfZt9V3ys/eb4XfKX+0f5D/Nv8bAVoB3IDmgKlAx8CVgX1BpKAFQdVBD4LNgkXBPSFwSGDI9pC78w3nC+d3hYLQgNDtoffCjMOWhX0fjgkPC68JfxhhE1EQ0b+AumDJgpYFryK9Issi70SZREmieqMVoxOim6Nfx3jHlMdIY61iV8ZeitOIE8R1x2Pjo+Ob4qcX+izcuXA8wT6hOOH6IuNFeYsuLNZYnL74+BLFJZwlRxLRiTGJLYnvOaGcBs700oCltUunuGzuLu4TngdvB2+S78ov508kuSaVJz1Kdk3enjyZ4p5SkfJUwBZUC56n+qfWpb5OC03bn/YpPSa9PQOXkZhxVEgRpgn7MrUz8zKHs8yzirOky5yX7Vw2JQoSNWVD2Yuyu8U02c/UgMREsl4ymuOWU5PzJjc690iecp4wb2C52fJNyyfyffO/XoFawV3RW6BbsLZgdKXnyvpV0Kqlq3pX668uWj2+xm/NgbWEtWlrfyi0LiwvfLkuZl1PkVbRmqKx9X7rW4sVikXFNza4bKjbiNoo2Di4ae6mqk0fS3glF0utSytK32/mbr74lc1XlV992pK0ZbDMoWzPVsxW4dbr29y3HShXLs8vH9sesr1zB2NHyY6XO5fsvFBhV1G3i7BLsktaGVzZXWVQtbXqfXVK9UiNV017rWbtptrXu3m7r+zx2NNWp1VXWvdur2DvzXq/+s4Go4aKfZh9OfseNkY39n/N+rq5SaOptOnDfuF+6YGIA33Njs3NLZotZa1wq6R18mDCwcvfeH/T3cZsq2+nt5ceAockhx5/m/jt9cNBh3uPsI60fWf4XW0HtaOkE+pc3jnVldIl7Y7rHj4aeLS3x6Wn43vL7/cf0z1Wc1zleNkJwomiE59O5p+cPpV16unp5NNjvUt675yJPXOtL7xv8GzQ2fPnfM+d6ffsP3ne9fyxC84Xjl5kXey65HCpc8B+oOMH+x86Bh0GO4cch7ovO13uGZ43fOKK+5XTV72vnrsWcO3SyPyR4etR12/eSLghvcm7+ehW+q3nt3Nuz9xZcxd9t+Se0r2K+5r3G340/bFd6iA9Puo9OvBgwYM7Y9yxJz9l//R+vOgh+WHFhM5E8yPbR8cmfScvP174ePxJ1pOZp8U/K/9c+8zk2Xe/ePwyMBU7Nf5c9PzTr5tfqL/Y/9LuZe902PT9VxmvZl6XvFF/c+At623/u5h3EzO577HvKz+Yfuj5GPTx7qeMT59+A/eE8/txAYbrAAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAAGYktHRAD/AP8A/6C9p5MAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfhCRsKAzXrzcJeAAADWUlEQVRYw+2YX4iUZRTGf7NtLCktu2pIutlGRoIZ2BPkxd7kmmmQhnShEbRChFSiXgSRpoHQHygvFDSLBJXF7UpD+mexSwgl0tNFEkpqlP91kdx1u5C27OYMfDvNzM43n7MZzLkZOPO+53u+c877nOf9oG51q1vdamq5WgSVtBBYBtwDjAP+AgaB74APbJ/+TwBKehrYDkwYZelnwBrbP48JQEl3Az9UAKzQVtjeXm5Bww0A9ynwSwLcqhTb35e0sSYAJa2Q9CfwRMT5AphsezNwMEWodZIeLfVnYxXA2oA+YHq4hqJU3YllrwCHUoT9qhSWhpTg9gC/JcABPFwADuAYcC1F6FskvVc1QEldki4BS4vsmV+43vYAcDhlcZ5NfYrjdO4A5pZZdsV2a2JPE7AaeLuK1j4B3AEcANbbPpYrA24D8EaFgZfY3itpBuAgZ4DfgbXAbttDEbcZWA5sAFrLxLwO3JcrAmwOsAdoT/Hmh4ArwIJ8VoF5tj1KhTqAb8q02rVcYvEk4F3guQy0+Aew0fY7KQ5eDjgCzCzZg5I6ga8zALsOfGu7IwOvDgDN/zrFku7NCG4QmJkFXNhTpWhmOEPQ14EW20ezjkzbfcCZAndnI3C+ing/AQtsn7nBSu01YFdUZant3nwPDgHjK+y1Jbb31UhHtgQ1HbD9eHKS9Fawfy8wpVbgwv6OJIwvFAu9wJMlNp0DXrT9yRgo/IZglsuFAPtKlPNj28vG8ArSkRAbIwAej/TmS34KmGv7ZAV9MxXYBPTbfjkjwLfi92AhUTcCF4CJwGHbj1QAbDGwEuhMuKfaPlflAZkF/BiUkxsht2wPA+vD90AM9GJBbpP0mKR+YF+AG44+Bfg8Q/Z2FpNdDQmi3BqDe1yxB0l6M08BwKRwdwOTgTbgKvCgpO4qsvclMBvoB3pK6kFJ06Mf80L0bEiuRUBTQhCsA3psX0jsnRikf2uI1UW2L44CbFrQ10Px8u22B8sKVkmvJpo1aUeBLba3lXngFOB74M5wfQh8FCNsIHwtwF3AC0BX+E4Dc4r1bzGATZHq24NqTgDzbf+aomS7gWcqvFLstN2V6uIu6X7g+cjYqSpPZVsolJeAGUVm+WZgv+3z3AwmaYKk1vrnsLr93+wfWRQXfg+gHPAAAAAASUVORK5CYII=" />
                        </defs>
                    </svg>
                </Button>
            </div>
        }
    },
]

export const getCategoryMatchesMobileColumns = (
    expandedMatchId: number | null,
    onToggleExpand: (id: number | null) => void
) => [
    {
        id: "time_status",
        name: "Time and status",
        data: null,
        render: (_data: null, _index: number, row: IMatchData): ReactNode => {
            return <>
                {row.data} {row.ora}
                <br />
                {
                    (row.rinviata === '1') ? <i className="fa fa-circle rinviata" aria-hidden="true" /> :
                        (row.chiusa === '1') ? <i className="fa fa-circle terminata" aria-hidden="true" /> :
                            (row.inCorso === '1') ? <i className="fa fa-circle in-corso" aria-hidden="true" /> :
                                (row.sospesa === '1') ? <i className="fa fa-circle sospesa" aria-hidden="true" /> :
                                    (row.inCorso === '0' && row.chiusa === '0') ? <i className="fa fa-circle-o da-giocare" aria-hidden="true" /> : <></>
                }
            </>
        }
    },
    {
        id: "teams",
        name: "Teams",
        data: null,
        render: (_data: null, _index: number, row: IMatchData): ReactNode => {
            const isExpanded = expandedMatchId === row.idPartita;

            return (
                <div className="h-100 d-flex flex-column align-items-start justify-content-center">
                    {/* Squadra Casa */}
                    <Link
                        href={`/societa/${row.idSquadraA}`}
                        title={row.nomeA}
                        className="col-12 text-truncate"
                    >
                        <span>{row.nomeA}</span>
                    </Link>
                    {isExpanded && row.marcatoriA.length > 0 && (
                        <div style={{ fontSize: "0.85rem", padding: "10px", width: "100%" }}>
                            {row.marcatoriA.map((m) => (
                                <div key={m.idMarcatore}>
                                    {m.goal} - {m.nome}
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Squadra Trasferta */}
                    <Link
                        href={`/societa/${row.idSquadraB}`}
                        title={row.nomeB}
                        className="col-12 text-truncate"
                    >
                        <span>{row.nomeB}</span>
                    </Link>
                    {isExpanded && row.marcatoriB.length > 0 && (
                        <div style={{ fontSize: "0.85rem", padding: "10px", width: "100%" }}>
                            {row.marcatoriB.map((m) => (
                                <div key={m.idMarcatore}>
                                    {m.goal} - {m.nome}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            );
        }
    },
    {
        id: "score",
        name: "Score",
        data: "risultato",
        render: (data: string, _index: number, row: IMatchData) => {
            const isExpanded = expandedMatchId === row.idPartita;

            const handleClick = () => {
                if (!onToggleExpand || data === "-") return;

                if (isExpanded) {
                    onToggleExpand(null); // chiude
                } else {
                    onToggleExpand(row.idPartita); // apre
                }
            };

            return (
                <div className="result-cell">
                    <span
                        onClick={handleClick}
                        className={
                            data !== "-"
                                ? `clickable ${!isExpanded ? "no-hover" : ""}`
                                : ""
                        }
                        >
                    {data}
                    </span>
                    {row.info && (
                        <div className="result-info">
                            {row.info}
                        </div>
                    )}
                </div>
            );
        }
    },
    {
        id: "risultati",
        name: "Risultati",
        hasButton: true,
        data: null,
        render: (_data: null, _index: number, _row: IMatchData) => {
            return <div className="h-100 d-flex align-items-center">
                <Button id={"send-results-" + _row.idPartita} className="send-results-btn" color="light" variant="circle" size="sm">
                    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <rect y="0.785156" width="21.4286" height="21.4286" rx="10.7143" fill="url(#pattern0_618_16212)" />
                        <defs>
                            <pattern id="pattern0_618_16212" patternContentUnits="objectBoundingBox" width="1" height="1">
                                <use xlinkHref="#image0_618_16212" transform="scale(0.025)" />
                            </pattern>
                            <image id="image0_618_16212" width="40" height="40" xlinkHref="data:image/png;base64,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" />
                        </defs>
                    </svg>
                </Button>
            </div>
        }
    },
]
